import { CATEGORIES, type Category } from "@volgo/core/contract";
import { CATEGORY_INFO, categoryStyle } from "./labels";

export function CategoryFilter({
  selected,
  onToggle,
}: {
  selected: readonly Category[];
  onToggle: (category: Category) => void;
}) {
  return (
    <fieldset className="cats">
      <legend className="sr">분류</legend>
      {CATEGORIES.map((c) => (
        <button
          key={c}
          type="button"
          className="cat"
          style={categoryStyle(c)}
          aria-pressed={selected.includes(c)}
          onClick={() => onToggle(c)}
        >
          {CATEGORY_INFO[c].label}
        </button>
      ))}
    </fieldset>
  );
}
